module.exports = __webpack_public_path__ + "img/events.9c48c687.jpg";